const primaryColor = 'hsl(26, 86%, 61%)';

export const STYLE_WITH_PRIMARY_COLOR = {
	'--primary': primaryColor,
	'--ring': primaryColor,
} as React.CSSProperties;
